import React from "react";
import Separator from "../../common/separator";
import {WorkData} from "../../data/work";
import WorkCard from "./work-card";
function Work() {
  const data = WorkData;
  return (
    <div className="flex flex-col w-full">
      <label className="text-3xl font-semibold">Experiences</label>
      <Separator />
      <div className="flex flex-col md:flex-row flex-wrap justify-between items-center my-6">
        {data.map((item) => {
          return <WorkCard item={item} />;
        })}
      </div>
    </div>
  );  
}

export default Work;